<div class="banner-header"></div>
<app-supplier-menu [supplierId]="supplier.id" [supplierName]="supplier.name" [menuItem]="3"></app-supplier-menu>

<div class="container">
  <h1 class="internal-title" *ngIf="!isNew()" translate>supplier-solutions/edit-solution</h1>
  <h1 class="internal-title" *ngIf="isNew()" translate>page-title/new-solution</h1>

  <div class="content-card">

    <div class="row">
      <div class="d-flex">

        <ng-container *ngIf="isNew()">
          <button class="btn-painel outline language-item small selected" type="button" mat-button *ngFor="let item of getOnlyEnglish()">
            <span ngClass="flag-icon flag-icon-{{ item.flag }}"></span>
            <span>{{item.name}}</span>
          </button>
        </ng-container>


        <ng-container *ngIf="!isNew()">
          <button class="btn-painel outline language-item small" *ngFor="let item of translatedLanguages" [ngClass]="{'selected': item.code === editingLanguage}" type="button" mat-button (click)="editLanguage(item.code)">
            <span ngClass="flag-icon flag-icon-{{ item.flag }}"></span>
            <span>{{item.name}}</span>
          </button>

          <button class="btn-painel outline language-item small" type="button" mat-button [matMenuTriggerFor]="menu" *ngIf="!isNew() && availableLanguages.length > 0">
            <i class="material-icons">add</i>
            <span [translate]="'painel-dashboard/add-language'"></span>
          </button>

          <mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false">
            <button mat-menu-item class="language-item menu" *ngFor="let item of availableLanguages" (click)="addLanguage(item)">
              <span ngClass="flag-icon flag-icon-{{ item.flag }}"></span>
              <span>{{item.name}}</span>
            </button>
          </mat-menu>
        </ng-container>
      </div>
    </div>

    <div class="inner-content">

      <form #f="ngForm" (keydown.enter)="$event.preventDefault()">

        <ng-container *ngIf="!isTranslation">
          <!-- SOLUTION NAME -->
          <div class="row align-items-center">
            <div class="col">
              <mat-form-field class="full-width">
                <input matInput id="solutionName" name="solutionName" type="text" placeholder="{{'painel-dashboard/solution-name' | translate}}" #solutionName="ngModel" [(ngModel)]="solution.name" [disabled]="loading" required>

                <mat-icon *ngIf="solutionName.errors && solutionName.touched" class="mat-error" matSuffix>error</mat-icon>
                <mat-error>
                  <span *ngIf="solutionName.errors?.required && solutionName.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-name' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION DESCRIPTION -->
          <div class="row align-items-center">
            <div class="col">
              <mat-form-field class="full-width">
                <textarea matInput id="description" [(ngModel)]="solution.description" name="description" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="6" #description="ngModel" [disabled]="loading" maxlength="2000" placeholder="{{'painel-dashboard/description' | translate}}"></textarea>
                <mat-hint align="end">
                  {{2000 - solution.description.length}} <span [innerHTML]="'edit-supplier/characters-left' | translate"></span>
                </mat-hint>

                <mat-icon *ngIf="description.errors && description.touched" class="mat-error" matSuffix>error</mat-icon>
                <mat-error>
                  <span *ngIf="description.errors?.maxlength && !description.errors?.required && description.touched" [translate]="'painel-dashboard/max-length'">Field Required</span>
                  <span *ngIf="description.errors?.required && description.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-description' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION RESULTS -->
          <div class="row align-items-center">
            <div class="col">
              <mat-form-field class="full-width">
                <textarea matInput id="results" [(ngModel)]="solution.results" name="results" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="6" #results="ngModel" [disabled]="loading" maxlength="500" placeholder="{{'painel-dashboard/results' | translate}}"></textarea>

                <mat-icon *ngIf="results.errors && results.touched" class="mat-error" matSuffix>error</mat-icon>
                <mat-error>
                  <span *ngIf="results.errors?.maxlength && !results.errors?.required && results.touched" [translate]="'painel-dashboard/max-length'">Field Required</span>
                  <span *ngIf="results.errors?.required && results.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-results' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- PREREQUISITES -->
          <div class="row align-items-center">
            <div class="col">
              <mat-form-field class="full-width">
                <textarea matInput id="prerequesite" [(ngModel)]="solution.preRequisites" name="prerequesite" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="6" #prerequesite="ngModel" [disabled]="loading" maxlength="500" placeholder="{{'painel-dashboard/prerequesite' | translate}}"></textarea>

                <mat-icon *ngIf="prerequesite.errors && prerequesite.touched" class="mat-error" matSuffix>error</mat-icon>
                <mat-error>
                  <span *ngIf="prerequesite.errors?.maxlength && !prerequesite.errors?.required && prerequesite.touched" [translate]="'painel-dashboard/max-length'">Field Required</span>
                  <span *ngIf="prerequesite.errors?.required && prerequesite.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-prerequisites' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION WEBSITE -->
          <div class="row align-items-center">
            <div class="col">
              <mat-form-field class="full-width">
                <input matInput id="website" name="website" type="text" placeholder="{{'painel-dashboard/website' | translate}}" #website="ngModel" [(ngModel)]="solution.website" [disabled]="loading">

                <mat-icon *ngIf="website.errors && website.touched" class="mat-error" matSuffix>error</mat-icon>
                <mat-error>
                  <span *ngIf="website.errors?.required && website.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-website' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- AVAILABLE WORLD WIDE -->
          <div class="row align-items-center mb-3">
            <div class="col">
              <!-- <div class="col col-auto"><label for="visible" class="fields-item--label" [translate]="'painel-dashboard/verified'">Verified</label></div> -->
              <mat-label [translate]="'painel-dashboard/solution-available-worldwide'" [floatLabel]="always"></mat-label>
                
              <div class="col-md">
                <mat-slide-toggle class="mt-3 mb-4" [color]="'primary'" (change)="onToggleChange()" [checked]="availableWorldwide">
                <!-- <mat-slide-toggle class="mt-3 mb-4" [color]="'primary'" (change)="onToggleChange()"> -->
                  <span *ngIf="availableWorldwide" [translate]="'painel-dashboard/yes'">Yes</span>
                  <span *ngIf="!availableWorldwide" [translate]="'painel-dashboard/no'">No</span>
                </mat-slide-toggle>
              </div>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-worldwide' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION AVAILABLE IN -->
          <div class="row align-items-center">
            <div class="col" *ngIf="!availableWorldwide">
              <mat-label [translate]="'painel-dashboard/solution-available-in'" [floatLabel]="always"></mat-label>

              <mat-form-field class="full-width">
                <ng-container>
                  <input type="text" matInput id="solutionAvailable" name="solutionAvailable" #solutionAvailableT="ngModel" placeholder="{{'painel-dashboard/solution-available-in-placeholder' | translate}}" (keyup)="searchTerm$.next($event.target.value)" [(ngModel)]="solutionAvailable" (blur)="blurSearch()" (focus)="focusSearch()">
                  <div class="citiesSearch" *ngIf="cities && solutionAvailable">
                    <ul>
                      <li *ngFor="let city of cities">
                        <a (click)="addLocationAvailable(city)">
                          <span class="dark01">{{city}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </mat-form-field>

              <!-- SELECT PLACE FOR SOLUTION AVAILABLE -->
              <div style="margin-bottom:20px;">
                <mat-chip-list>
                  <mat-chip *ngFor="let item of solution.availablePlaces" [removable]="true" color="primary" selected (removed)="removeAvailable(item)">
                    {{item}}
                    <mat-icon matChipRemove>close</mat-icon>
                  </mat-chip>
                </mat-chip-list>
              </div>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-available' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION IMPLEMENTED IN -->
          <div class="row align-items-center">
            <div class="col">
              <mat-form-field class="full-width">
                <mat-label [translate]="'painel-dashboard/solution-implemented'" [floatLabel]="always"></mat-label>
                <input type="text" matInput id="solutionImplemented" name="solutionImplemented" #solutionImplementedT="ngModel" placeholder="{{'painel-dashboard/solution-implemented-in-placeholder' | translate}}" [(ngModel)]="solutionImplemented" (keyup)="searchCities()" (blur)="blurSearch()" (focus)="focusSearch()">
                <div class="citiesSearch" *ngIf="completeCities && solutionImplemented">
                  <ul>
                    <li *ngFor="let city of completeCities">
                      <a (click)="addLocationImplemented(city.name, city.id)">
                        <span class="dark01">{{city.name}}</span>
                        <small class="grey01">{{ (city.region) ? city.region + ', ' : '' }}{{city.country}}</small> </a>
                    </li>
                  </ul>
                </div>
              </mat-form-field>

              <div style="margin-top:-10px;margin-bottom:20px;">
                <mat-chip-list>
                  <mat-chip *ngFor="let item of solution.implementedCities; let i = index" [removable]="true" color="primary" selected (removed)="removeLocation(item.cityId)">
                    {{item.cityName}}
                    <mat-icon matChipRemove>close</mat-icon>
                  </mat-chip>
                </mat-chip-list>
              </div>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-implemented' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION COST -->
          <h4>
            <span [translate]="'configuration/COST'">COST</span>
            <small [translate]="'configuration/estimated'">estimado</small>
          </h4>
          <p [translate]="'supplier-single-solution/cost'">Lorem ipsum dolor sit amet, consectetur adipiscing elitam a augue id nunc eleifend consequat sed at quam. Nulla ac libero ullamcorper, pulvinar sapien ac, tristique risus</p>
          <div class="row">
            <div class="col">
              <mat-slider class="full-width" [max]="1000000" [min]="0" [step]="25000">
                <input matSliderThumb name="cost" [(ngModel)]="solution.costValue">
              </mat-slider>

              <div class="d-flex justify-content-between">
                <label>USD 0</label>
                <label>USD +1.000.000</label>
              </div>
              <div class="d-flex justify-content-around">
                <label class="model">{{maskCostValue(solution.costValue)}}</label>
              </div>
            </div>
          </div>

          <!-- SOLUTION ESTIMATED TIME -->
          <h4>
            <span [translate]="'configuration/TIME'">TIME</span>
            <small [translate]="'configuration/estimated'">estimado</small>
          </h4>
          <p [translate]="'supplier-single-solution/time'">Lorem ipsum dolor sit amet, consectetur adipiscing elitam a augue id nunc eleifend consequat sed at quam. Nulla ac libero ullamcorper, pulvinar sapien ac, tristique risus</p>
          <div class="row">
            <div class="col">
              <mat-slider class="full-width" [max]="60" [min]="0" [step]="3">
                <input matSliderThumb name="time" [(ngModel)]="solution.timeValue">
              </mat-slider>

              <div class="d-flex justify-content-between">
                <label>1 <span translate>painel-dashboard/month</span></label>
                <label>+ 5 <span translate>painel-dashboard/years</span></label>
              </div>
              <div class="d-flex justify-content-around">
                <label class="model">{{maskTimeValue(solution.timeValue)}}</label>
              </div>
            </div>
          </div>

          <!-- SOLUTION CATEGORIES -->
          <h4 [translate]="'painel-solution-inner/solution-category'">SOLUTION CATEGORY</h4>
          <p [translate]="'supplier-single-solution/solution-category'">Lorem ipsum dolor sit amet, consectetur adipiscing elitam a augue id nunc eleifend consequat sed at quam. Nulla ac libero ullamcorper, pulvinar sapien ac, tristique risus</p>
          <div class="row">
            <div class="col">
              <mat-selection-list class="checkbox-list sm" [(ngModel)]="solution.solutionCategory" name="solutionCategory">
                <mat-list-option *ngFor="let option of types?.solutionCategories" checkboxPosition="before" [selected]="(solution.solutionCategory?.indexOf(option) > -1)" [value]="option">
                  <span translate>painel-dashboard/category-{{option}}</span>
                </mat-list-option>
              </mat-selection-list>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-categories' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION TAGS -->
          <div class="row align-items-center">
            <div class="col">
              <mat-form-field class="full-width" style="padding-top:15px;">
                <mat-label [translate]="'cities-solution-inter/tags'" [floatLabel]="always"></mat-label>
                <input type="text" matInput id="tags" name="tags" #solutionAvailableT="ngModel" [(ngModel)]="tag" (keydown.enter)="addTag()">
              </mat-form-field>

              <div style="margin-top:-10px;margin-bottom:20px;">

                <mat-chip-list>
                  <mat-chip *ngFor="let item of solution.tags" [removable]="true" color="primary" selected (removed)="removeTag(item)">
                    {{item}}
                    <mat-icon matChipRemove>close</mat-icon>
                  </mat-chip>
                </mat-chip-list>

              </div>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-tags' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION AREAS -->
          <h4 [translate]="'painel-dashboard/areas'"></h4>
          <p [translate]="'supplier-single-solution/areas'">Lorem ipsum dolor sit amet, consectetur adipiscing elitam a augue id nunc eleifend consequat sed at quam. Nulla ac libero ullamcorper, pulvinar sapien ac, tristique risus</p>

          <div class="row">
            <div class="col">
              <mat-selection-list class="checkbox-list sm" [(ngModel)]="solution.areaIds" name="areaIds">
                <mat-list-option *ngFor="let item of areas" checkboxPosition="before" [selected]="(solution.areaIds?.indexOf(item.id) > -1)" [value]="item.id">
                  <span [innerHTML]="('configuration/' + item.id) | translate"></span>
                </mat-list-option>
              </mat-selection-list>
            </div>
            <div>
              <mat-icon aria-hidden="false" matTooltipPosition="above" [matTooltip]="'edit-supplier/input-areas' | translate" aria-label="tooltip-icon">help_outline</mat-icon>
            </div>
          </div>

          <!-- SOLUTION PHOTOS AND VIDEOS -->
          <h4 [translate]="'painel-dashboard/photos-and-videos'"></h4>
          <p [translate]="'supplier-single-solution/photos-and-videos'">Lorem ipsum dolor sit amet, consectetur adipiscing elitam a augue id nunc eleifend consequat sed at quam. Nulla ac libero ullamcorper, pulvinar sapien ac, tristique risus</p>
          <div class="ng2FileDrop" ng2FileDrop [ngClass]="{'has-file': uploaderImages.hasFile}" (fileOver)="fileOverBase($event, 'images')" [uploader]="uploaderImages.upload">
            <i class="icon icon-upload"></i>
            <em translate="painel-dashboard/drag-and-drop-pics">Drag and drop the photos or videos here</em>
            <span class="button">
              <span [translate]="'painel-dashboard/choose-photos'"> CHOOSE PICTURES</span>
              <input type="file" name="file" ng2FileSelect [uploader]="uploaderImages.upload" onFileSelected="startFiles()" multiple />
            </span>
            <small class="max-filesize" [translate]="'painel-dashboard/max-filesize'">Maximum file size: 4MB</small>
          </div>

          <div class="upload-files" *ngIf="uploaderImages.upload.queue">
            <ul>
              <li *ngFor="let item of uploaderImages.upload.queue">
                <div class="row align-items-center">
                  <div class="col-sm-7">
                    <span class="name-progress">{{ item?.file?.name }} ({{ item?.file?.size/1024/1024 | number:'.2' }}mb)</span>
                  </div>
                  <div class="col-sm-4">
                    <div class="mini-progress-bar gray">
                      <div class="mini-progress-bar--inner" [ngStyle]="{ 'width.%' : item.progress }"></div>
                    </div>
                  </div>
                  <div class="col-sm-1 text-right">
                    <button type="button" (click)="item.remove()"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </li>
            </ul>

            <div class="item item-thumb">
              <div class="row">
                <div class="col-md-4 col-lg-2" *ngFor="let image of solution.imageVideos">
                  <div class="item-card item-img">
                    <button type="button" (click)="removeImage(image.url)"><i class="fa fa-trash"></i></button>
                    <a [href]="image.url" target="_blank" *ngIf="hasImage(image.url)">
                      <img [src]="image.url">
                    </a>

                    <div class="video-wrap" *ngIf="!hasImage(image.url)">
                      <video [src]="image.url" controls="false"></video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SOLUTION DOCS -->
          <!-- <h4 [translate]="'painel-dashboard/documents'"></h4>
          <p [translate]="'supplier-single-solution/documents'">Lorem ipsum dolor sit amet, consectetur adipiscing elitam a augue id nunc eleifend consequat sed at quam. Nulla ac libero ullamcorper, pulvinar sapien ac, tristique risus</p>
          <div class="ng2FileDrop" ng2FileDrop [ngClass]="{'has-file': uploaderDocuments.hasFile}" (fileOver)="fileOverBase($event, 'documents')" [uploader]="uploaderDocuments.upload">
            <i class="icon icon-upload"></i>
            <em [translate]="'painel-dashboard/drag-and-drop-docs'">Drag and drop the documents here</em>
            <span class="button">
              <span [translate]="'painel-dashboard/choose-docs'">CHOOSE DOCUMENTS</span>
              <input type="file" name="file" ng2FileSelect [uploader]="uploaderDocuments.upload" onFileSelected="startFiles()" multiple />
            </span>
            <small class="max-filesize" [translate]="'painel-dashboard/max-filesize'">Maximum file size: 4MB</small>
          </div>

          <div class="upload-files" *ngIf="uploaderDocuments.upload.queue">
            <ul>
              <li *ngFor="let item of uploaderDocuments.upload.queue">
                <div class="row align-items-center">
                  <div class="col-sm-7">
                    <span class="name-progress">{{ item?.file?.name }} ({{ item?.file?.size/1024/1024 | number:'.2' }}mb)</span>
                  </div>
                  <div class="col-sm-4">
                    <div class="mini-progress-bar gray">
                      <div class="mini-progress-bar--inner" [ngStyle]="{ 'width.%' : item.progress }"></div>
                    </div>
                  </div>
                  <div class="col-sm-1 text-right">
                    <button type="button" (click)="item.remove()"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </li>
            </ul>

            <ul *ngIf="hasDocuments()" class="list-documents">
              <li *ngFor="let document of solution.documentUrls">
                <div class="row">
                  <div class="col">
                    <a [href]="document" target="_blank">
                      {{getFileName(document)}}
                    </a>
                  </div>
                  <div class="col col-auto">
                    <button type="button" (click)="removeDoc(document)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </li>
            </ul>
          </div> -->

        </ng-container>

        <ng-container *ngIf="isTranslation">

          <div class="row">
            <div class="col">
              <div class="alert-attention">
                <p [translate]="'painel-dashboard/displaying-only-fields'">Displaying only the fields that can be translated.</p>
                <p [translate]="'painel-dashboard/all-other-fields'">All other fields will be displayed with their original content.</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <mat-form-field class="full-width">
                <input matInput id="solutionName" name="solutionName" type="text" placeholder="{{'create-account/company' | translate}}" #solutionName="ngModel" [(ngModel)]="solutionTranslated.name" [disabled]="loading" required>

                <mat-icon *ngIf="solutionName.errors && solutionName.touched" class="mat-error" matSuffix>error</mat-icon>
                <mat-error>
                  <span *ngIf="solutionName.errors?.required && solutionName.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <mat-form-field class="full-width">
                <textarea matInput id="description" [(ngModel)]="solutionTranslated.description" name="description" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="6" #description="ngModel" [disabled]="loading" maxlength="2000" placeholder="{{'painel-dashboard/description' | translate}}"></textarea>
                <mat-hint align="end">
                  {{200 - solutionTranslated.description.length}} <span [innerHTML]="'edit-supplier/characters-left' | translate"></span>
                </mat-hint>

                <mat-icon *ngIf="description.errors && description.touched" class="mat-error" matSuffix>error</mat-icon>
                <mat-error>
                  <span *ngIf="description.errors?.maxlength && !description.errors?.required && description.touched" [translate]="'painel-dashboard/max-length'">Field Required</span>
                  <span *ngIf="description.errors?.required && description.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <textarea matInput id="results" [(ngModel)]="solutionTranslated.results" name="results" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="6" #results="ngModel" [disabled]="loading" maxlength="500" placeholder="{{'painel-dashboard/results' | translate}}" #results="ngModel"></textarea>
    
                    <mat-icon *ngIf="results.errors && results.touched" class="mat-error" matSuffix>error</mat-icon>
                    <mat-error>
                      <span *ngIf="results.errors?.maxlength && !results.errors?.required && results.touched" [translate]="'painel-dashboard/max-length'">Field Required</span>
                      <span *ngIf="results.errors?.required && results.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div> -->

          <!-- <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <textarea matInput id="prerequesite" [(ngModel)]="solution.preRequisites" name="prerequesite" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="6" #prerequesite="ngModel" [disabled]="loading" maxlength="500" placeholder="{{'painel-dashboard/prerequesite' | translate}}" #prerequesite="ngModel"></textarea>
    
                    <mat-icon *ngIf="prerequesite.errors && prerequesite.touched" class="mat-error" matSuffix>error</mat-icon>
                    <mat-error>
                      <span *ngIf="prerequesite.errors?.maxlength && !prerequesite.errors?.required && prerequesite.touched" [translate]="'painel-dashboard/max-length'">Field Required</span>
                      <span *ngIf="prerequesite.errors?.required && prerequesite.touched" [translate]="'painel-dashboard/field-required'">Field Required</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div> -->
        </ng-container>

        <div class="row d-flex align-items-center">
          <div class="col">
            <button class="btn-branded" [disabled]="loading" [class.disabled]="loading" (click)="onSubmit()">
              <span [translate]="'painel-dashboard/save'">SAVE</span>
            </button>
          </div>
          <!-- <div class="col col-auto" *ngIf="!isNew()">
            <button class="btn-invisible" type="button" (click)="confirmationMoveTrash()" [disabled]="loading">
              <i *ngIf="!loading" class="material-icons">delete</i>
              <span *ngIf="!loading" class="text-uppercase" [translate]="'edit-supplier/move-trash'">Delete company</span>
            </button>
          </div> -->
        </div>

      </form>
    </div>

  </div>
</div>